// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskDetail-module__font-s-10___tk8bX {
  font-size: 10px !important;
}

.TaskDetail-module__font-s-12___lPmfs {
  font-size: 12px !important;
}

.TaskDetail-module__font-s-13___jMsWZ {
  font-size: 13px !important;
}

.TaskDetail-module__font-s-14___KkptG {
  font-size: 14px !important;
}

.TaskDetail-module__font-s-15___JX3zU {
  font-size: 15px !important;
}

.TaskDetail-module__font-s-16___W7KdN {
  font-size: 16px !important;
}

.TaskDetail-module__font-s-18___pdGeJ {
  font-size: 18px !important;
}

.TaskDetail-module__font-s-20___fN8a1 {
  font-size: 20px !important;
}

.TaskDetail-module__font-s-22___IBFHB {
  font-size: 22px !important;
}

.TaskDetail-module__font-s-28___BulW0 {
  font-size: 28px !important;
}

.TaskDetail-module__font-w-400___PR_7X {
  font-weight: 400 !important;
}

.TaskDetail-module__font-w-500___vy399 {
  font-weight: 500 !important;
}

.TaskDetail-module__font-w-600___n73JD {
  font-weight: 600 !important;
}

.TaskDetail-module__font-w-700___Y17WW {
  font-weight: 700 !important;
}

.TaskDetail-module__p-5___ohf1p {
  padding: 5px !important;
}

.TaskDetail-module__p-12___lFh0h {
  padding: 12px !important;
}

.TaskDetail-module__p-16___yeWHQ {
  padding: 16px !important;
}

.TaskDetail-module__p-30___GINf6 {
  padding: 30px !important;
}

.TaskDetail-module__p-b-0___GtEQT {
  padding-bottom: 0 !important;
}

.TaskDetail-module__p-b-5___rsS4j {
  padding-bottom: 5px !important;
}

.TaskDetail-module__p-b-10___eElco {
  padding-bottom: 10px !important;
}

.TaskDetail-module__p-b-12___U016T {
  padding-bottom: 12px !important;
}

.TaskDetail-module__p-b-16___k4cBh {
  padding-bottom: 16px !important;
}

.TaskDetail-module__p-b-18___nTBD1 {
  padding-bottom: 18px !important;
}

.TaskDetail-module__p-b-20___d1AFg {
  padding-bottom: 20px !important;
}

.TaskDetail-module__p-b-25___csfVz {
  padding-bottom: 25px !important;
}

.TaskDetail-module__p-b-30___n1VVu {
  padding-bottom: 30px !important;
}

.TaskDetail-module__p-b-50___O0NEU {
  padding-bottom: 50px !important;
}

.TaskDetail-module__p-t-0___GFnBe {
  padding-top: 0 !important;
}

.TaskDetail-module__p-t-12___noQWS {
  padding-top: 12px !important;
}

.TaskDetail-module__p-t-16___qzJgK {
  padding-top: 16px !important;
}

.TaskDetail-module__p-t-18___LOl2g {
  padding-top: 18px !important;
}

.TaskDetail-module__p-t-20___ZP6Kx {
  padding-top: 20px !important;
}

.TaskDetail-module__p-t-30___yTwam {
  padding-top: 30px !important;
}

.TaskDetail-module__p-t-40___kYZaw {
  padding-top: 40px !important;
}

.TaskDetail-module__p-t-50___xmshq {
  padding-top: 50px !important;
}

.TaskDetail-module__p-l-20___Gq8r7 {
  padding-left: 20px !important;
}

.TaskDetail-module__p-l-30___SpKD5 {
  padding-left: 30px !important;
}

.TaskDetail-module__p-l-40___E_KDJ {
  padding-left: 40px !important;
}

.TaskDetail-module__p-r-16___M6ov0 {
  padding-right: 16px !important;
}

.TaskDetail-module__p-r-20___Riw2T {
  padding-right: 20px !important;
}

.TaskDetail-module__p-r-30___DVmhn {
  padding-right: 30px !important;
}

.TaskDetail-module__p-r-50___k0WFK {
  padding-right: 50px !important;
}

.TaskDetail-module__p-r-60___dbf1G {
  padding-right: 60px !important;
}

.TaskDetail-module__m-b-1___q7Kg3 {
  margin-bottom: 1px !important;
}

.TaskDetail-module__m-b-2___UYZPZ {
  margin-bottom: 2px !important;
}

.TaskDetail-module__m-b-6___CZp99 {
  margin-bottom: 6px !important;
}

.TaskDetail-module__m-b-8___vLTXF {
  margin-bottom: 8px !important;
}

.TaskDetail-module__m-b-10___tj_vr {
  margin-bottom: 10px !important;
}

.TaskDetail-module__m-b-14___I6Kxw {
  margin-bottom: 14px !important;
}

.TaskDetail-module__m-b-16___PjnmT {
  margin-bottom: 16px !important;
}

.TaskDetail-module__m-b-20___u06vk {
  margin-bottom: 20px !important;
}

.TaskDetail-module__m-b-22___LZQLF {
  margin-bottom: 22px !important;
}

.TaskDetail-module__m-b-24___YElEx {
  margin-bottom: 24px !important;
}

.TaskDetail-module__m-b-30___tePlO {
  margin-bottom: 30px !important;
}

.TaskDetail-module__m-b-32___lVOyk {
  margin-bottom: 32px !important;
}

.TaskDetail-module__m-b-40___LnAGP {
  margin-bottom: 40px !important;
}

.TaskDetail-module__m-t-2___TE0KV {
  margin-top: 2px !important;
}

.TaskDetail-module__m-t-3___vgQ9T {
  margin-top: 3px !important;
}

.TaskDetail-module__m-t-4___gbJ2t {
  margin-top: 4px !important;
}

.TaskDetail-module__m-t-5___rFhss {
  margin-top: 5px !important;
}

.TaskDetail-module__m-t-8___mrBzG {
  margin-top: 8px !important;
}

.TaskDetail-module__m-t-10___XGahh {
  margin-top: 10px !important;
}

.TaskDetail-module__m-t-15___ION80 {
  margin-top: 15px !important;
}

.TaskDetail-module__m-t-16___pOAMU {
  margin-top: 16px !important;
}

.TaskDetail-module__m-t-20___VetFR {
  margin-top: 20px !important;
}

.TaskDetail-module__m-t-22___k6IOt {
  margin-top: 22px !important;
}

.TaskDetail-module__m-t-30___kI4ku {
  margin-top: 30px !important;
}

.TaskDetail-module__m-t-32___QUZdu {
  margin-top: 32px !important;
}

.TaskDetail-module__m-l-auto___ERvRW {
  margin-left: auto !important;
}

.TaskDetail-module__m-l-4___iRW1g {
  margin-left: 4px !important;
}

.TaskDetail-module__m-l-5___t564O {
  margin-left: 5px !important;
}

.TaskDetail-module__m-l-6___E3FXp {
  margin-left: 6px !important;
}

.TaskDetail-module__m-l-8___3xEKS {
  margin-left: 8px !important;
}

.TaskDetail-module__m-l-10___vF9bl {
  margin-left: 10px !important;
}

.TaskDetail-module__m-l-16___EZ8cb {
  margin-left: 16px !important;
}

.TaskDetail-module__m-l-20___YZqc7 {
  margin-left: 20px !important;
}

.TaskDetail-module__m-l-24___wBeOE {
  margin-left: 24px !important;
}

.TaskDetail-module__m-l-30___PEl9Z {
  margin-left: 30px !important;
}

.TaskDetail-module__m-l-35___QWf8V {
  margin-left: 35px !important;
}

.TaskDetail-module__m-l-40___Um8pQ {
  margin-left: 40px !important;
}

.TaskDetail-module__m-r-8___tAvnT {
  margin-right: 8px !important;
}

.TaskDetail-module__m-r-10___Valsh {
  margin-right: 10px !important;
}

.TaskDetail-module__m-r-16___uBptO {
  margin-right: 16px !important;
}

.TaskDetail-module__m-r-20___DW3qE {
  margin-right: 20px !important;
}

.TaskDetail-module__m-r-24___BWeQu {
  margin-right: 24px !important;
}

.TaskDetail-module__m-r-30___jnnvP {
  margin-right: 30px !important;
}

.TaskDetail-module__m-r-40___YV94l {
  margin-right: 40px !important;
}

.TaskDetail-module__border-r-3___QLgWp {
  border-radius: 3px !important;
}

.TaskDetail-module__border-r-4___l5OCZ {
  border-radius: 4px !important;
}

.TaskDetail-module__border-r-6___t0l36 {
  border-radius: 6px !important;
}

.TaskDetail-module__border-r-10___OO3gM {
  border-radius: 10px !important;
}

.TaskDetail-module__border-r-12___y5nzh {
  border-radius: 12px !important;
}

.TaskDetail-module__border-r-16___f4Xq_ {
  border-radius: 16px !important;
}

.TaskDetail-module__border-r-50___HLy9h {
  border-radius: 50% !important;
}

.TaskDetail-module__primary-border___l5B3m {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskDetail-module__primary-border-b___jNPSd {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskDetail-module__primary-border-t___lSGqD {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskDetail-module__primary-border-l___ZelvH {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskDetail-module__primary-border-r___CfDnj {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TaskDetail-module__secondary-border___N1_1j {
  border: 1px solid #637768;
}

.TaskDetail-module__secondary-border-b___uY5SI {
  border-bottom: 1px solid #637768;
}

.TaskDetail-module__secondary-border-t___Ij6dL {
  border-top: 1px solid #637768;
}

.TaskDetail-module__secondary-border-l___WLzs2 {
  border-left: 1px solid #637768;
}

.TaskDetail-module__secondary-border-r___WT6Qw {
  border-right: 1px solid #637768;
}

.TaskDetail-module__gap-0___UrW_Q {
  gap: 0 !important;
}

.TaskDetail-module__gap-2___e_xvZ {
  gap: 2px !important;
}

.TaskDetail-module__gap-4___bSMd7 {
  gap: 4px !important;
}

.TaskDetail-module__gap-5___K80b6 {
  gap: 5px !important;
}

.TaskDetail-module__gap-6___O2KXM {
  gap: 6px !important;
}

.TaskDetail-module__gap-8___PlawC {
  gap: 8px !important;
}

.TaskDetail-module__gap-10___J8s2e {
  gap: 10px !important;
}

.TaskDetail-module__gap-12___xpTJJ {
  gap: 12px !important;
}

.TaskDetail-module__gap-14___vA9qP {
  gap: 14px !important;
}

.TaskDetail-module__gap-16___eLwIr {
  gap: 16px !important;
}

.TaskDetail-module__gap-18___XbDTV {
  gap: 18px !important;
}

.TaskDetail-module__gap-20___eljzZ {
  gap: 20px !important;
}

.TaskDetail-module__gap-24___fP7QS {
  gap: 24px !important;
}

.TaskDetail-module__gap-26___Hmtxl {
  gap: 26px !important;
}

.TaskDetail-module__gap-30___sigpu {
  gap: 30px !important;
}

.TaskDetail-module__gap-32___T1oMc {
  gap: 32px !important;
}

.TaskDetail-module__gap-40___pcfpN {
  gap: 40px !important;
}

.TaskDetail-module__gap-50___TAmEH {
  gap: 50px !important;
}

.TaskDetail-module__flex-1___HXeq7 {
  flex: 1;
}

.TaskDetail-module__flex-none___IOhvU {
  flex: none !important;
}

.TaskDetail-module__flex-column___C64Px {
  display: flex;
  flex-direction: column !important;
}

.TaskDetail-module__flex-row___qq5oD {
  display: flex;
  flex-direction: row !important;
}

.TaskDetail-module__vertically-centered___zhMKo {
  display: flex;
  align-items: center !important;
}

.TaskDetail-module__horizontally-centered___ko2IX {
  display: flex;
  justify-content: center !important;
}

.TaskDetail-module__horizontally-end___n6lOR {
  display: flex;
  justify-content: end !important;
}

.TaskDetail-module__vertically-start___fVBgS {
  display: flex;
  align-items: start !important;
}

.TaskDetail-module__space-between___p7B6D {
  display: flex;
  justify-content: space-between !important;
}

.TaskDetail-module__flex-wrap___RaAGC {
  flex-wrap: wrap !important;
}

.TaskDetail-module__height-100___y0RMb {
  height: 100%;
}

.TaskDetail-module__width-50___ccOm6 {
  width: 50% !important;
}

.TaskDetail-module__width-100___lixaj {
  width: 100%;
}

.TaskDetail-module__cursor-pointer___nxTPC {
  cursor: pointer;
}

.TaskDetail-module__cursor-not-allowed___c_XL7 {
  cursor: not-allowed !important;
}

.TaskDetail-module__absolute-centered___PM4dB {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TaskDetail-module__absolute___iAxYP {
  position: absolute;
}

.TaskDetail-module__relative___hSStO {
  position: relative;
}

.TaskDetail-module__fixed___BpqPW {
  position: fixed;
}

.TaskDetail-module__visible___emUhv {
  opacity: 1;
}

.TaskDetail-module__invisible___HgKNF {
  opacity: 0;
}

.TaskDetail-module__col-90___QqMKn {
  width: 90% !important;
}

.TaskDetail-module__col-auto___m9pOB {
  width: auto !important;
}

.TaskDetail-module__medical-tabs___xV_P3 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TaskDetail-module__medical-table-new___AGGSt {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TaskDetail-module__medical-table-new___AGGSt:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TaskDetail-module__medical-table-new___AGGSt::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TaskDetail-module__medical-table-new___AGGSt::-webkit-scrollbar-track {
  display: none;
}
.TaskDetail-module__medical-table-new___AGGSt.TaskDetail-module__no-pagination___i4AJ3 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TaskDetail-module__medical-table-new___AGGSt.TaskDetail-module__no-pagination___i4AJ3:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TaskDetail-module__medical-table-new___AGGSt.TaskDetail-module__no-pagination___i4AJ3::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TaskDetail-module__medical-table-new___AGGSt.TaskDetail-module__no-pagination___i4AJ3::-webkit-scrollbar-track {
  display: none;
}

.TaskDetail-module__medical-table-empty___SwkK2 {
  padding: 14px 40px !important;
}

.TaskDetail-module__icon-btn___H480f {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TaskDetail-module__search-icon___RewJg {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TaskDetail-module__disable-select___JlXRf {
  user-select: none;
}

.TaskDetail-module__break-word___KYwX7 {
  word-break: break-word;
}

.TaskDetail-module__popup-clear-btn___L8gd6 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TaskDetail-module__scroll-m-b-20___AtkMB {
  scroll-margin-bottom: 20px;
}

.TaskDetail-module__root___nWvUV {
  line-height: 1.5;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
}

.TaskDetail-module__unclaimedBanner___Uu_dM {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #fefce8;
  border-top: 1px solid #fde68a;
  border-bottom: 1px solid #fde68a;
}

.TaskDetail-module__claimedBanner___Cwl0n {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 20px;
  background: #f0fdf4;
  border-bottom: 1px solid #bbf7d0;
}

.TaskDetail-module__followingBanner___ljM3I {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 20px;
  background: #f0f9ff;
  border-top: 1px solid #bae6fd;
  border-bottom: 1px solid #bae6fd;
}

.TaskDetail-module__claimButtonWrap___xZgxS {
  position: relative;
  display: inline-flex;
}

.TaskDetail-module__claimNote___VlEiP {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 240px;
  padding: 6px 10px;
  border-radius: 6px;
  background: #18181b;
  color: #fafafa;
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  z-index: 20;
  pointer-events: none;
}

.TaskDetail-module__claimNote___VlEiP::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #18181b;
}

.TaskDetail-module__claimNoteOk___lFDBB {
  color: #fafafa;
}

.TaskDetail-module__claimNoteOver___X8E9q {
  background: #92400e;
}

.TaskDetail-module__claimNoteOver___X8E9q::after {
  border-top-color: #92400e;
}

.TaskDetail-module__claimNoteBreach___mEaUH {
  background: #b91c1c;
}

.TaskDetail-module__claimNoteBreach___mEaUH::after {
  border-top-color: #b91c1c;
}

.TaskDetail-module__systemBanner___TFn9i {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 20px;
  background: #eff6ff;
  border-top: 1px solid #bfdbfe;
  border-bottom: 1px solid #bfdbfe;
}

.TaskDetail-module__systemBannerCopy___k9PIY {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.TaskDetail-module__systemLabel___jpnx3 {
  font-size: 12px;
  font-weight: 700;
  color: #1d4ed8;
  line-height: 1.2;
}

.TaskDetail-module__systemText___bAq0p {
  font-size: 12px;
  color: #3f3f46;
  line-height: 1.35;
}

.TaskDetail-module__capacityWarningBanner___GnEKz {
  padding: 10px 20px;
  border-bottom: 1px solid transparent;
}

.TaskDetail-module__capacityWarningBannerOver___M5iDA {
  background: #fffbeb;
  border-bottom-color: #fde68a;
}

.TaskDetail-module__capacityWarningBannerBreach___UvG7l {
  background: #fef2f2;
  border-bottom-color: #fecaca;
}

.TaskDetail-module__capacityWarningTitle___b3PV5 {
  font-size: 13px;
  font-weight: 600;
}

.TaskDetail-module__capacityWarningBannerOver___M5iDA .TaskDetail-module__capacityWarningTitle___b3PV5 {
  color: #92400e;
}

.TaskDetail-module__capacityWarningBannerBreach___UvG7l .TaskDetail-module__capacityWarningTitle___b3PV5 {
  color: #b91c1c;
}

.TaskDetail-module__capacityWarningText___MMatA {
  margin-top: 2px;
  font-size: 12px;
  color: #52525b;
  line-height: 1.4;
}

.TaskDetail-module__capacityWarningSlaText___xItDE {
  margin-top: 2px;
  font-size: 12px;
  color: #b91c1c;
  line-height: 1.4;
}

.TaskDetail-module__waitingOnSubtasksBanner___IQK2l {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 20px;
  background: #eff6ff;
  border-top: 1px solid #bfdbfe;
  border-bottom: 1px solid #bfdbfe;
}

.TaskDetail-module__allSubtasksCompletedBanner___WuTf5 {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 20px;
  background: #f0fdf4;
  border-top: 1px solid #bbf7d0;
  border-bottom: 1px solid #bbf7d0;
}

.TaskDetail-module__blockedBanner___f5Ng4 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #f4f4f5;
  border-bottom: 1px solid #e4e4e7;
}

.TaskDetail-module__completedBanner___qP_6H {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 20px;
  background: #f0fdf4;
  border-top: 1px solid #bbf7d0;
  border-bottom: 1px solid #bbf7d0;
}

.TaskDetail-module__canceledBanner___z2FX_ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 20px;
  background: #fef2f2;
  border-top: 1px solid #fecaca;
  border-bottom: 1px solid #fecaca;
}

.TaskDetail-module__unableToCompleteBanner___u20gb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 20px;
  background: #fff7ed;
  border-top: 1px solid #fed7aa;
  border-bottom: 1px solid #fed7aa;
}

.TaskDetail-module__unclaimedBannerCopy___KsOXK {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__claimedBannerCopy___nU7EE {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__blockedBannerCopy___zX_R1 {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__waitingOnSubtasksCopy___a5RuY {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__allSubtasksCompletedCopy___stkyI {
  flex: 1;
  min-width: 0;
}

.TaskDetail-module__blockedBannerIconWrap___Ghhy6 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #a1a1aa;
}

.TaskDetail-module__waitingOnSubtasksIconWrap___rttwb {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #0b79b7;
}

.TaskDetail-module__allSubtasksCompletedIconWrap___IJaZT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #166534;
}

.TaskDetail-module__blockedBannerIcon___xiAb9 {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.TaskDetail-module__waitingOnSubtasksIcon___MCFcZ {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.TaskDetail-module__allSubtasksCompletedIcon___tfDfM {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.TaskDetail-module__unclaimedLabel___CCP_L {
  font-size: 12px;
  font-weight: 600;
  color: #a16207;
}

.TaskDetail-module__unclaimedText___clcKS {
  font-size: 10px;
  color: #a1a1aa;
  line-height: 1.4;
  margin-top: 2px;
}

.TaskDetail-module__followingLabel___IgUXj {
  font-size: 12px;
  font-weight: 600;
  color: #0369a1;
}

.TaskDetail-module__claimedLabel___IKRXJ {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #166534;
}

.TaskDetail-module__claimedDot___vN0xw {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #22c55e;
  flex-shrink: 0;
}

.TaskDetail-module__blockedLabel___msHYi {
  font-size: 13px;
  font-weight: 600;
  color: #52525b;
}

.TaskDetail-module__waitingOnSubtasksLabel___wbb1Z {
  font-size: 13px;
  font-weight: 600;
  color: #0b79b7;
}

.TaskDetail-module__allSubtasksCompletedLabel___kPTJl {
  font-size: 13px;
  font-weight: 600;
  color: #166534;
}

.TaskDetail-module__waitingOnSubtasksText___gGjn6 {
  font-size: 10px;
  color: #0b79b7;
  line-height: 1.4;
  margin-top: 2px;
}

.TaskDetail-module__allSubtasksCompletedText___uIFN1 {
  font-size: 10px;
  color: #166534;
  line-height: 1.4;
  margin-top: 2px;
}

.TaskDetail-module__blockedWaitingText___M7P3z {
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.35;
  color: #a1a1aa;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__blockedWaitingLabel___Iqkdz {
  font-weight: 500;
}

.TaskDetail-module__completedLabel___EDMgd {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #166534;
}

.TaskDetail-module__canceledLabel___Nzsj5 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #b91c1c;
}

.TaskDetail-module__unableToCompleteLabel___KOaWO {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #c2410c;
}

.TaskDetail-module__completedCheck___J_qDv {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-size: 12px;
  font-weight: 700;
}

.TaskDetail-module__canceledMark___W5Wni {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #fee2e2;
  color: #b91c1c;
}

.TaskDetail-module__unableToCompleteMark___op5tA {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #fed7aa;
  color: #c2410c;
  font-size: 12px;
  font-weight: 700;
}

.TaskDetail-module__priorityBadge___ADfFk {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
}

.TaskDetail-module__priorityBadgecritical___JucaQ {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
  font-weight: 600;
}

.TaskDetail-module__priorityBadgehigh___jyZfd {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #c2410c;
}

.TaskDetail-module__priorityBadgemedium___I6IMI {
  background: #fefce8;
  border-color: #fef08a;
  color: #a16207;
}

.TaskDetail-module__priorityBadgelow___gF1Z8 {
  background: #f9fafb;
  border-color: #e5e7eb;
  color: #6b7280;
}

.TaskDetail-module__claimedTime___MtNCK {
  font-size: 11px;
  color: #a1a1aa;
}

.TaskDetail-module__unclaimedBannerActions___fbYRt {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TaskDetail-module__followingBannerActions___ZREd_ {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TaskDetail-module__claimButton___AuLFq {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #18181b;
  color: #fafafa;
  cursor: pointer;
}

.TaskDetail-module__claimButtonBreach___Wv_CV {
  background: #ffffff;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

.TaskDetail-module__followButton___YD50W {
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #0369a1;
  cursor: pointer;
}

.TaskDetail-module__unfollowButton___EIk68 {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #d4d4d8;
  background: #fafafa;
  color: #52525b;
  cursor: pointer;
}

.TaskDetail-module__claimButton___AuLFq:disabled,
.TaskDetail-module__followButton___YD50W:disabled,
.TaskDetail-module__unfollowButton___EIk68:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.TaskDetail-module__closeButton___IrhIh {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  color: #a1a1aa;
  cursor: pointer;
}
.TaskDetail-module__closeButton___IrhIh:hover:not(:disabled) {
  color: #52525b;
}
.TaskDetail-module__closeButton___IrhIh:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__caption___akEbw {
  font-size: 15px;
  color: #52525b;
  line-height: 1.5;
  margin-bottom: 8px;
}

.TaskDetail-module__taskDescription___MjbIn {
  font-size: 15px;
  color: #52525b;
  line-height: 1.5;
  margin-bottom: 8px;
}

.TaskDetail-module__badgesRow___TezKK {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.TaskDetail-module__waitingStatusBadge___OAa6v {
  background: #eff6ff;
  color: #0b79b7;
  border: 1px solid #93c5fd;
}

.TaskDetail-module__athenaLinkWrap___GbZ6E {
  margin-top: 8px;
}

.TaskDetail-module__sectionLabel___ySsR2 {
  font-size: 12px;
  font-weight: 600;
  color: #71717a;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 6px;
  line-height: 1.3333;
}

.TaskDetail-module__evidenceSpacer___Jw7SR {
  flex: 1;
}

.TaskDetail-module__evidenceRef___MDKDx {
  font-family: "IBM Plex Mono", monospace;
  font-size: 9px;
  color: #a1a1aa;
}

.TaskDetail-module__evidenceSummary___ZqYQK {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #27272a;
}

.TaskDetail-module__evidenceSource___d4_fe {
  font-size: 15px;
  line-height: 1.5;
  color: #3f3f46;
}

.TaskDetail-module__evidenceSourceRef___HkhSh {
  display: block;
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  line-height: 1.4;
  color: #a1a1aa;
  word-break: break-all;
}

.TaskDetail-module__sopText___ukw4Q {
  font-size: 15px;
  line-height: 1.5;
  color: #3f3f46;
}

.TaskDetail-module__linkedTasksList___DC3Bf {
  display: flex;
  flex-direction: column;
}

.TaskDetail-module__linkedTaskRow___h0riB {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 16px;
  border: 0;
  border-radius: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.TaskDetail-module__linkedTaskRow___h0riB:hover {
  background: #fafafa;
}

.TaskDetail-module__linkedTaskRow___h0riB:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__linkedTaskTitle___VKwK8 {
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: #18181b;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__linkedTaskMeta___uyW1M {
  display: flex;
  align-items: center;
  gap: 6px;
}

.TaskDetail-module__linkedTaskOwner___g9CPN {
  font-size: 13px;
  color: #71717a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__linkedTaskDue___wZrH9 {
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  color: #a1a1aa;
  white-space: nowrap;
}

.TaskDetail-module__subtasksList____xImD {
  display: flex;
  flex-direction: column;
}

.TaskDetail-module__subtaskRow___ACxYH {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 0;
  border-radius: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  min-width: 0;
}

.TaskDetail-module__subtaskRow___ACxYH:hover {
  background: #fafafa;
}

.TaskDetail-module__subtaskRow___ACxYH:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__subtaskRowCompleted___uzJd1 {
  border-color: #bbf7d0;
  border-left: 2px solid #86efac;
  background: #f0fdf4;
  padding-left: 8px;
}

.TaskDetail-module__subtaskRowCompleted___uzJd1:hover {
  border-color: #86efac;
  background: #f0fdf4;
}

.TaskDetail-module__subtaskRowCanceled___q0LFC {
  border-color: #fecaca;
  border-left: 2px solid #f87171;
  background: #fef2f2;
  padding-left: 8px;
}

.TaskDetail-module__subtaskRowCanceled___q0LFC:hover {
  border-color: #f87171;
  background: #fef2f2;
}

.TaskDetail-module__subtaskStatusDot___DFKGh {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #f59e0b;
  flex-shrink: 0;
}

.TaskDetail-module__subtaskStatusDotCompleted___fajup {
  background: #22c55e;
}

.TaskDetail-module__subtaskStatusDotCanceled____gQnD {
  background: #ef4444;
}

.TaskDetail-module__subtaskRowPrimary___nSYfm {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.TaskDetail-module__subtaskTitle___jFauS {
  display: block;
  width: 100%;
  font-size: 15px;
  font-weight: 500;
  color: #18181b;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__subtaskTitleCompleted___GDBuI {
  color: #166534;
  text-decoration: line-through;
}

.TaskDetail-module__subtaskTitleCanceled___d6ibn {
  color: #b91c1c;
  text-decoration: line-through;
}

.TaskDetail-module__subtaskRowCompleted___uzJd1 .TaskDetail-module__subtaskMeta___Lp3DD,
.TaskDetail-module__subtaskRowCompleted___uzJd1 .TaskDetail-module__subtaskDue___MgjVl {
  color: #166534;
}

.TaskDetail-module__subtaskRowCompleted___uzJd1 .TaskDetail-module__subtaskTeamIcon___xb1IZ {
  background: #dcfce7;
  border-color: #86efac;
  color: #166534;
}

.TaskDetail-module__subtaskRowCanceled___q0LFC .TaskDetail-module__subtaskMeta___Lp3DD,
.TaskDetail-module__subtaskRowCanceled___q0LFC .TaskDetail-module__subtaskDue___MgjVl {
  color: #b91c1c;
}

.TaskDetail-module__subtaskRowCanceled___q0LFC .TaskDetail-module__subtaskTeamIcon___xb1IZ {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
}

.TaskDetail-module__subtaskRowMeta___DRJ9D {
  min-width: 0;
  width: 132px;
  flex: 0 0 132px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
}

.TaskDetail-module__subtaskTeamWrap___eRzKd {
  min-width: 0;
  width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
  overflow: hidden;
}

.TaskDetail-module__subtaskTeamIcon___xb1IZ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  color: #b45309;
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  flex-shrink: 0;
}

.TaskDetail-module__subtaskMeta___Lp3DD {
  min-width: 0;
  font-size: 13px;
  color: #71717a;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TaskDetail-module__subtaskDue___MgjVl {
  flex: 0 0 70px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  color: #a1a1aa;
  text-align: right;
}

.TaskDetail-module__subtaskDueUrgent___caCtc {
  color: #b91c1c;
}

.TaskDetail-module__subtaskTrashButton___Zj9fU {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  flex: 0 0 24px;
  border-radius: 4px;
  background: transparent;
  color: #a1a1aa;
  cursor: pointer;
}

.TaskDetail-module__subtaskTrashButton___Zj9fU:hover:not(:disabled) {
  background: #f4f4f5;
  color: #71717a;
}

.TaskDetail-module__subtaskTrashButton___Zj9fU:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__subtaskTrashButtonDisabled___HYGH2 {
  cursor: default;
  opacity: 0.45;
}

.TaskDetail-module__parentTaskCard___NPVLb {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 16px;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.TaskDetail-module__parentTaskCard___NPVLb:hover {
  background: transparent;
}

.TaskDetail-module__parentTaskCard___NPVLb:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__parentTaskIconWrap___XnChB {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #9ca3af;
}

.TaskDetail-module__parentTaskIcon___hB4nN {
  width: 14px;
  height: 14px;
  stroke-width: 1.8;
}

.TaskDetail-module__parentTaskCopy___EUGMt {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.TaskDetail-module__parentTaskTitle___sl_Fv {
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.35;
}

.TaskDetail-module__parentTaskSummary___EUcvU {
  font-size: 11px;
  color: #71717a;
  line-height: 1.45;
}

.TaskDetail-module__parentTaskMeta___QooHR {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 11px;
  color: #a1a1aa;
  line-height: 1.35;
}

.TaskDetail-module__parentTaskOwnerWrap___doTjs {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.TaskDetail-module__parentTaskOwnerBadge___B6Vn1 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 999px;
  background: #e5e7eb;
  color: #52525b;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  flex-shrink: 0;
}

.TaskDetail-module__parentTaskArrow___o1i1P {
  width: 14px;
  height: 14px;
  color: #a1a1aa;
  flex-shrink: 0;
  margin-top: 1px;
}

.TaskDetail-module__assessmentBadgesRow____zg6h {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
}

.TaskDetail-module__assessmentTypeBadge___hhPMT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 3px 8px;
  border: 1px solid #c4b5fd;
  border-radius: 4px;
  background: #f3e8ff;
  color: #6d28d9;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.TaskDetail-module__assessmentVariantBadge___xhBx9 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 3px 8px;
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  background: #ffffff;
  color: #3f3f46;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.TaskDetail-module__caregiverAssistedBadge___JNE5l {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 3px 8px;
  border: 1px solid #fde68a;
  border-radius: 4px;
  background: #fffbeb;
  color: #92400e;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.TaskDetail-module__sectionActions___bZ0yQ {
  display: flex;
  flex-direction: column;
}

.TaskDetail-module__primaryActionSection___EPr5z {
  padding: 12px 20px;
  background: #ffffff;
}

.TaskDetail-module__primaryActionsRow___CrIgJ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 6px;
}

.TaskDetail-module__decisionGroup___h4NkO {
  grid-column: 1/-1;
}

.TaskDetail-module__decisionGroup___h4NkO + .TaskDetail-module__cancelTaskAction___hzd73 {
  grid-column: 1/-1;
}

.TaskDetail-module__decisionActionsRow___MIayQ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));
  gap: 6px;
}

.TaskDetail-module__secondaryActionSection___bUWVZ {
  padding: 12px 20px;
  background: #fafafa;
  border-top: 1px solid #f4f4f5;
}

.TaskDetail-module__secondaryActionSectionStandalone___M9mT1 {
  border-top: none;
}

.TaskDetail-module__cancelReasonPanel___c_Wby {
  margin-top: 8px;
}

.TaskDetail-module__cancelReasonInput___JYV3l {
  width: 100%;
  min-height: 72px;
  resize: vertical;
  padding: 8px 10px;
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 1.4;
  color: #27272a;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
}

.TaskDetail-module__cancelReasonInput___JYV3l:focus {
  outline: 2px solid #a1a1aa;
  outline-offset: 1px;
}

.TaskDetail-module__cancelActionRow___Y17p5 {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.TaskDetail-module__cancelTaskAction___hzd73 {
  color: #991b1b;
  border-color: #fecaca;
}

.TaskDetail-module__cancelTaskAction___hzd73:hover,
.TaskDetail-module__cancelTaskAction___hzd73:focus-visible {
  background: #fef2f2;
}

.TaskDetail-module__cancelTaskAction___hzd73:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.TaskDetail-module__primaryAction___jWo7M {
  width: 100%;
  padding: 8px 16px;
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  background: #18181b;
  color: #fafafa;
  cursor: pointer;
}

.TaskDetail-module__primaryAction___jWo7M:disabled,
.TaskDetail-module__assessmentCompleteAction___WMNjw:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.TaskDetail-module__blockedIndicatorAction___xPvsF {
  grid-column: 1/-1;
  background: #f4f4f5;
  color: #a1a1aa;
  border: 1px solid #e4e4e7;
}

.TaskDetail-module__blockedIndicatorAction___xPvsF:disabled {
  cursor: not-allowed;
  opacity: 1;
}

.TaskDetail-module__cancelTaskAction___hzd73.TaskDetail-module__cancelTaskActionFullWidth___iW1Rp {
  grid-column: 1/-1;
  width: 100%;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background: #dc2626;
  border-color: #dc2626;
}

.TaskDetail-module__cancelTaskAction___hzd73.TaskDetail-module__cancelTaskActionFullWidth___iW1Rp:hover,
.TaskDetail-module__cancelTaskAction___hzd73.TaskDetail-module__cancelTaskActionFullWidth___iW1Rp:focus-visible {
  background: #b91c1c;
  border-color: #b91c1c;
}

.TaskDetail-module__primaryAction___jWo7M:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__assessmentCompleteAction___WMNjw {
  width: 100%;
  padding: 8px 16px;
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #71717a;
  cursor: pointer;
}

.TaskDetail-module__assessmentCompleteAction___WMNjw:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TaskDetail-module__secondaryAction___Q7h19 {
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 5px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #71717a;
  cursor: pointer;
}

.TaskDetail-module__secondaryActionsRow___akDaS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: nowrap;
}

.TaskDetail-module__secondaryActionsRowClaimed___BSDTH {
  align-items: flex-start;
  flex-direction: column;
}

.TaskDetail-module__secondaryActionsGroup___yIeXB {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  min-width: 0;
}

.TaskDetail-module__secondaryActionsStatusGroupClaimed___VdKae {
  width: 100%;
}

.TaskDetail-module__statusActionWrap___q688q {
  position: relative;
}

.TaskDetail-module__secondaryAction___Q7h19:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

@media (max-width: 720px) {
  .TaskDetail-module__secondaryActionsRow___akDaS {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .TaskDetail-module__secondaryActionsGroup___yIeXB {
    width: 100%;
    flex-wrap: wrap;
  }
}
.TaskDetail-module__blockDropdown___TAMqT {
  position: absolute;
  left: 0;
  bottom: calc(100% + 8px);
  width: 200px;
  padding: 4px 0;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);
  z-index: 10;
}

.TaskDetail-module__blockDropdownItem___x6C2y {
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: transparent;
  color: #52525b;
  font-size: 14px;
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
}

.TaskDetail-module__blockDropdownItem___x6C2y:hover,
.TaskDetail-module__blockDropdownItem___x6C2y:focus-visible {
  background: #fafafa;
  outline: none;
}

.TaskDetail-module__escalateDropdown___eSL46 {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  width: 240px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);
  z-index: 10;
}

.TaskDetail-module__escalateDropdownLabel___LMItM {
  margin-bottom: 6px;
  color: #71717a;
  font-size: 12px;
  font-weight: 600;
}

.TaskDetail-module__escalateTargetOptions___OwQN3 {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}

.TaskDetail-module__escalateTargetOption___GPXS3 {
  padding: 6px 8px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  color: #52525b;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.TaskDetail-module__escalateTargetOption___GPXS3:hover,
.TaskDetail-module__escalateTargetOption___GPXS3:focus-visible {
  background: #fafafa;
  outline: none;
}

.TaskDetail-module__escalateTargetOptionActive___K94Li {
  background: #ffffff;
  border-color: #18181b;
  color: #18181b;
  font-weight: 600;
}

.TaskDetail-module__escalateReasonInput___aFuAN {
  width: 100%;
  margin-bottom: 10px;
  padding: 8px 10px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  color: #18181b;
  font-size: 14px;
}

.TaskDetail-module__escalateReasonInput___aFuAN:focus {
  border-color: #f59e0b;
  outline: none;
}

.TaskDetail-module__escalateSubmitButton___XjcI5 {
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: #fbbf24;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.TaskDetail-module__escalateSubmitButton___XjcI5:hover,
.TaskDetail-module__escalateSubmitButton___XjcI5:focus-visible {
  background: #f59e0b;
  outline: none;
}

.TaskDetail-module__escalateSubmitButton___XjcI5:disabled {
  background: #fcd34d;
  cursor: not-allowed;
}

.TaskDetail-module__alertAction___R0zuF {
  padding: 4px 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
  background: #ffffff;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  cursor: pointer;
}
.TaskDetail-module__alertAction___R0zuF:hover:not(:disabled) {
  border-color: #a1a1aa;
}
.TaskDetail-module__alertAction___R0zuF:disabled {
  opacity: 0.5;
  cursor: default;
}

.TaskDetail-module__statusActionLabel____Cpk6 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.TaskDetail-module__headline___DK3wu {
  border-bottom: 1px solid #e4e4e7;
}

.TaskDetail-module__taskVisitLine___OUXBc {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  margin: 0;
  font-size: 15px;
  line-height: 1.375;
  color: #18181b;
}

.TaskDetail-module__taskVisitName___Ec6XB {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.TaskDetail-module__taskVisitWhen___ot0tf {
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: #71717a;
}

.TaskDetail-module__summary___OuzP3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 20px;
}
.TaskDetail-module__summary___OuzP3 > * {
  margin: 0;
}

.TaskDetail-module__memberName___jpXO2 {
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
}

.TaskDetail-module__memberMeta___d4vQW {
  font-size: 14px;
  color: #3f3f46;
}

.TaskDetail-module__mrn___C9c_R {
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  color: #71717a;
}

.TaskDetail-module__linkRow___reI_t {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -8px;
}

.TaskDetail-module__quiet___q0Ulj {
  font-size: 14px;
  color: #71717a;
}

.TaskDetail-module__bookingMeta___aBYKN {
  font-size: 14px;
  color: #3f3f46;
}

.TaskDetail-module__taskFacts___s_HWw {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 0 13px;
  margin: 0;
  font-size: 14px;
}
.TaskDetail-module__taskFacts___s_HWw dt {
  color: #71717a;
}
.TaskDetail-module__taskFacts___s_HWw dd {
  margin: 0;
  color: #18181b;
}

.TaskDetail-module__dueUrgent___EBNwB {
  font-weight: 600;
  color: #991b1b;
}

.TaskDetail-module__summaryBadge___SAmyF {
  font-size: 13px;
  line-height: 22px;
  padding: 0 8px;
}

.TaskDetail-module__topics___wVzjD {
  container-type: inline-size;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #e4e4e7;
}

.TaskDetail-module__linkedTaskRow___h0riB + .TaskDetail-module__linkedTaskRow___h0riB,
.TaskDetail-module__subtaskRow___ACxYH + .TaskDetail-module__subtaskRow___ACxYH {
  border-top: 1px solid #f4f4f5;
}

.TaskDetail-module__subtaskRow___ACxYH {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  column-gap: 8px;
  row-gap: 2px;
}

.TaskDetail-module__subtaskStatusDot___DFKGh {
  grid-column: 1;
  grid-row: 1/span 2;
}

.TaskDetail-module__subtaskRowPrimary___nSYfm {
  grid-column: 2/4;
  grid-row: 1;
}

.TaskDetail-module__subtaskRowMeta___DRJ9D {
  grid-column: 2;
  grid-row: 2;
}

.TaskDetail-module__subtaskDue___MgjVl {
  grid-column: 3;
  grid-row: 2;
}

.TaskDetail-module__subtaskTrashButton___Zj9fU {
  grid-column: 4;
  grid-row: 1/span 2;
}

.TaskDetail-module__primaryActionsRow___CrIgJ .TaskDetail-module__secondaryAction___Q7h19 {
  padding: 8px 16px;
  font-size: 14px;
}

.TaskDetail-module__sopLink___hyy3N {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
}
.TaskDetail-module__sopLink___hyy3N:disabled {
  color: #a1a1aa;
  cursor: default;
}

.TaskDetail-module__delegateMore___Yfu0Q {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.TaskDetail-module__delegateMore___Yfu0Q:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.TaskDetail-module__delegateMore___Yfu0Q {
  outline: none;
}
.TaskDetail-module__delegateMore___Yfu0Q:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.TaskDetail-module__delegateMore___Yfu0Q:disabled, .TaskDetail-module__delegateMore___Yfu0Q[aria-disabled=true] {
  color: #a1a1aa;
  cursor: default;
}
.TaskDetail-module__delegateMore___Yfu0Q {
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/TaskDetail/TaskDetail.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,kBAAA;EACA,oBAAA;AA8pBF;;AA3pBA;EACE,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,oBAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;AA8pBF;;AA3pBA;EACE,yBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;AA8pBF;;AA3pBA;EACE,yBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AA8pBF;;AA3pBA;EACE,kBAAA;EACA,oCAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,4BAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,4BAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AA8pBF;;AA3pBA;EACE,OAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,OAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,OAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,OAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,OAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,gBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA8pBF;;AA3pBA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA8pBF;;AA3pBA;;;EAGE,mBAAA;EACA,aAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA3pBE;EACE,0BAAA;EACA,mBAAA;AA6pBJ;;AAzpBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA4pBF;;AAzpBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA4pBF;;AAzpBA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA4pBF;;AAzpBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA4pBF;;AAzpBA;EACE,eAAA;AA4pBF;;AAzpBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AA4pBF;;AAzpBA;EACE,OAAA;AA4pBF;;AAzpBA;EACE,uCAAA;EACA,cAAA;EACA,cAAA;AA4pBF;;AAzpBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA4pBF;;AAzpBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA4pBF;;AAzpBA;EACE,cAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AA4pBF;;AAzpBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA4pBF;;AAzpBA;EACE,aAAA;EACA,sBAAA;AA4pBF;;AAzpBA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AA2pBJ;;AAvpBA;EACE,mBAAA;AA0pBF;;AAvpBA;EACE,0BAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA0pBF;;AAvpBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,aAAA;EACA,sBAAA;AA0pBF;;AAvpBA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;EAEF,YAAA;AAwpBF;;AArpBA;EACE,mBAAA;AAwpBF;;AArpBA;EACE,0BAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAwpBF;;AArpBA;EACE,qBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAwpBF;;AArpBA;EACE,qBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,mBAAA;AAwpBF;;AArpBA;EACE,mBAAA;AAwpBF;;AArpBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAwpBF;;AArpBA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,cAAA;EACA,6BAAA;AAwpBF;;AArpBA;EACE,cAAA;EACA,6BAAA;AAwpBF;;AArpBA;;EAEE,cAAA;AAwpBF;;AArpBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAwpBF;;AArpBA;;EAEE,cAAA;AAwpBF;;AArpBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAwpBF;;AArpBA;EACE,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;AAwpBF;;AArpBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,cAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAwpBF;;AArpBA;EACE,cAAA;AAwpBF;;AArpBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAwpBF;;AArpBA;EACE,mBAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,0BAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,eAAA;EACA,aAAA;AAwpBF;;AArpBA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAwpBF;;AArpBA;EACE,uBAAA;AAwpBF;;AArpBA;EACE,0BAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAwpBF;;AArpBA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAwpBF;;AArpBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAwpBF;;AArpBA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAwpBF;;AArpBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAwpBF;;AArpBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AAwpBF;;AArpBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,sBAAA;AAwpBF;;AArpBA;EACE,kBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,2DAAA;EACA,QAAA;AAwpBF;;AArpBA;EACE,iBAAA;AAwpBF;;AArpBA;EACE,iBAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,0DAAA;EACA,QAAA;AAwpBF;;AArpBA;EACE,kBAAA;EACA,mBAAA;EACA,6BAAA;AAwpBF;;AArpBA;EACE,gBAAA;AAwpBF;;AArpBA;EACE,eAAA;AAwpBF;;AArpBA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,0BAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAwpBF;;AArpBA;EACE,cAAA;EACA,qBAAA;AAwpBF;;AArpBA;;EAEE,mBAAA;AAwpBF;;AArpBA;EACE,mBAAA;EACA,aAAA;AAwpBF;;AArpBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAwpBF;;AArpBA;;EAEE,mBAAA;EACA,YAAA;AAwpBF;;AArpBA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAwpBF;;AArpBA;EACE,mBAAA;EACA,UAAA;AAwpBF;;AArpBA;EACE,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AAwpBF;;AArpBA;;EAEE,mBAAA;EACA,qBAAA;AAwpBF;;AArpBA;EACE,0BAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAwpBF;;AArpBA;EACE,0BAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;AAwpBF;;AArpBA;EACE,uBAAA;EACA,sBAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AAwpBF;;AArpBA;EACE,WAAA;AAwpBF;;AArpBA;EACE,kBAAA;AAwpBF;;AArpBA;EACE,0BAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE;IACE,uBAAA;IACA,eAAA;EAwpBF;EArpBA;IACE,WAAA;IACA,eAAA;EAupBF;AACF;AAtpBC;EACC,kBAAA;EACA,OAAA;EACA,wBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,WAAA;AAwpBF;;AArpBA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAwpBF;;AArpBA;;EAEE,mBAAA;EACA,aAAA;AAwpBF;;AArpBA;EACE,kBAAA;EACA,QAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;EACA,WAAA;AAwpBF;;AArpBA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kFACE;AAupBJ;;AAlpBA;;EAEE,mBAAA;EACA,aAAA;AAqpBF;;AAlpBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAqpBF;;AAlpBA;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAqpBF;;AAlpBA;EACE,qBAAA;EACA,aAAA;AAqpBF;;AAlpBA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAqpBF;;AAlpBA;;EAEE,mBAAA;EACA,aAAA;AAqpBF;;AAlpBA;EACE,mBAAA;EACA,mBAAA;AAqpBF;;AAlpBA;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAqpBF;AAnpBE;EACE,qBAAA;AAqpBJ;AAlpBE;EACE,YAAA;EACA,eAAA;AAopBJ;;AAhpBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAmpBF;;AAhpBA;EACE,gCAAA;AAmpBF;;AAhpBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAmpBF;;AAhpBA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAmpBF;;AAhpBA;EACE,eAAA;EACA,kCAAA;EACA,cAAA;AAmpBF;;AAhpBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAmpBF;AAjpBE;EACE,SAAA;AAmpBJ;;AA/oBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAkpBF;;AA/oBA;EACE,eAAA;EACA,cAAA;AAkpBF;;AA/oBA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AAkpBF;;AA/oBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAkpBF;;AA/oBA;EACE,eAAA;EACA,cAAA;AAkpBF;;AA/oBA;EACE,eAAA;EACA,cAAA;AAkpBF;;AA/oBA;EACE,aAAA;EACA,0CAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AAkpBF;AAhpBE;EACE,cAAA;AAkpBJ;AA/oBE;EACE,SAAA;EACA,cAAA;AAipBJ;;AA7oBA;EACE,gBAAA;EACA,cAAA;AAgpBF;;AA7oBA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAgpBF;;AA7oBA;EACE,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;AAgpBF;;AA5oBA;;EAEE,6BAAA;AA+oBF;;AA5oBA;EACE,aAAA;EACA,oDAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AA+oBF;;AA5oBA;EACE,cAAA;EACA,kBAAA;AA+oBF;;AA5oBA;EACE,gBAAA;EACA,WAAA;AA+oBF;;AA5oBA;EACE,cAAA;EACA,WAAA;AA+oBF;;AA5oBA;EACE,cAAA;EACA,WAAA;AA+oBF;;AA5oBA;EACE,cAAA;EACA,kBAAA;AA+oBF;;AA5oBA;EACE,iBAAA;EACA,eAAA;AA+oBF;;AA5oBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;AA+oBF;AA7oBE;EACE,cAAA;EACA,eAAA;AA+oBJ;;AA3oBA;EE1hDE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,sDAAA;AFyqEF;AEvqEE;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AFyqEJ;AArqBA;EEniDE,aAAA;AF2sEF;AEzsEE;EACE,0BAAA;EACA,mBALuB;AFgtE3B;AE3qEE;EAEE,cAAA;EACA,eAAA;AF4qEJ;AAhrBA;EAEE,eAAA;AAirBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.root {\n  line-height: 1.5;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.unclaimedBanner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #fefce8;\n  border-top: 1px solid #fde68a;\n  border-bottom: 1px solid #fde68a;\n}\n\n.claimedBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 20px;\n  background: #f0fdf4;\n  border-bottom: 1px solid #bbf7d0;\n}\n\n.followingBanner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #f0f9ff;\n  border-top: 1px solid #bae6fd;\n  border-bottom: 1px solid #bae6fd;\n}\n\n.claimButtonWrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.claimNote {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  width: max-content;\n  max-width: 240px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  background: #18181b;\n  color: #fafafa;\n  font-size: 11px;\n  line-height: 1.4;\n  text-align: center;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);\n  z-index: 20;\n  pointer-events: none;\n}\n\n.claimNote::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #18181b;\n}\n\n.claimNoteOk {\n  color: #fafafa;\n}\n\n.claimNoteOver {\n  background: #92400e;\n}\n\n.claimNoteOver::after {\n  border-top-color: #92400e;\n}\n\n.claimNoteBreach {\n  background: #b91c1c;\n}\n\n.claimNoteBreach::after {\n  border-top-color: #b91c1c;\n}\n\n.systemBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #eff6ff;\n  border-top: 1px solid #bfdbfe;\n  border-bottom: 1px solid #bfdbfe;\n}\n\n.systemBannerCopy {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.systemLabel {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1d4ed8;\n  line-height: 1.2;\n}\n\n.systemText {\n  font-size: 12px;\n  color: #3f3f46;\n  line-height: 1.35;\n}\n\n.capacityWarningBanner {\n  padding: 10px 20px;\n  border-bottom: 1px solid transparent;\n}\n\n.capacityWarningBannerOver {\n  background: #fffbeb;\n  border-bottom-color: #fde68a;\n}\n\n.capacityWarningBannerBreach {\n  background: #fef2f2;\n  border-bottom-color: #fecaca;\n}\n\n.capacityWarningTitle {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.capacityWarningBannerOver .capacityWarningTitle {\n  color: #92400e;\n}\n\n.capacityWarningBannerBreach .capacityWarningTitle {\n  color: #b91c1c;\n}\n\n.capacityWarningText {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #52525b;\n  line-height: 1.4;\n}\n\n.capacityWarningSlaText {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #b91c1c;\n  line-height: 1.4;\n}\n\n.waitingOnSubtasksBanner {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #eff6ff;\n  border-top: 1px solid #bfdbfe;\n  border-bottom: 1px solid #bfdbfe;\n}\n\n.allSubtasksCompletedBanner {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #f0fdf4;\n  border-top: 1px solid #bbf7d0;\n  border-bottom: 1px solid #bbf7d0;\n}\n\n.blockedBanner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #f4f4f5;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.completedBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #f0fdf4;\n  border-top: 1px solid #bbf7d0;\n  border-bottom: 1px solid #bbf7d0;\n}\n\n.canceledBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #fef2f2;\n  border-top: 1px solid #fecaca;\n  border-bottom: 1px solid #fecaca;\n}\n\n.unableToCompleteBanner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #fff7ed;\n  border-top: 1px solid #fed7aa;\n  border-bottom: 1px solid #fed7aa;\n}\n\n.unclaimedBannerCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.claimedBannerCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.blockedBannerCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.waitingOnSubtasksCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.allSubtasksCompletedCopy {\n  flex: 1;\n  min-width: 0;\n}\n\n.blockedBannerIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #a1a1aa;\n}\n\n.waitingOnSubtasksIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #0b79b7;\n}\n\n.allSubtasksCompletedIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: #166534;\n}\n\n.blockedBannerIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2;\n}\n\n.waitingOnSubtasksIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2;\n}\n\n.allSubtasksCompletedIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2;\n}\n\n.unclaimedLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #a16207;\n}\n\n.unclaimedText {\n  font-size: 10px;\n  color: #a1a1aa;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.followingLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0369a1;\n}\n\n.claimedLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #166534;\n}\n\n.claimedDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #22c55e;\n  flex-shrink: 0;\n}\n\n.blockedLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: #52525b;\n}\n\n.waitingOnSubtasksLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0b79b7;\n}\n\n.allSubtasksCompletedLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: #166534;\n}\n\n.waitingOnSubtasksText {\n  font-size: 10px;\n  color: #0b79b7;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.allSubtasksCompletedText {\n  font-size: 10px;\n  color: #166534;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.blockedWaitingText {\n  margin-top: 2px;\n  font-size: 12px;\n  line-height: 1.35;\n  color: #a1a1aa;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.blockedWaitingLabel {\n  font-weight: 500;\n}\n\n.completedLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #166534;\n}\n\n.canceledLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #b91c1c;\n}\n\n.unableToCompleteLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #c2410c;\n}\n\n.completedCheck {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #dcfce7;\n  color: #166534;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.canceledMark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.unableToCompleteMark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #fed7aa;\n  color: #c2410c;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.priorityBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 6px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.priorityBadgecritical {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.priorityBadgehigh {\n  background: #fff7ed;\n  border-color: #fed7aa;\n  color: #c2410c;\n}\n\n.priorityBadgemedium {\n  background: #fefce8;\n  border-color: #fef08a;\n  color: #a16207;\n}\n\n.priorityBadgelow {\n  background: #f9fafb;\n  border-color: #e5e7eb;\n  color: #6b7280;\n}\n\n.claimedTime {\n  font-size: 11px;\n  color: #a1a1aa;\n}\n\n.unclaimedBannerActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.followingBannerActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.claimButton {\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #18181b;\n  color: #fafafa;\n  cursor: pointer;\n}\n\n.claimButtonBreach {\n  background: #ffffff;\n  color: #b91c1c;\n  border: 1px solid #fca5a5;\n}\n\n.followButton {\n  padding: 6px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n  color: #0369a1;\n  cursor: pointer;\n}\n\n.unfollowButton {\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #d4d4d8;\n  background: #fafafa;\n  color: #52525b;\n  cursor: pointer;\n}\n\n.claimButton:disabled,\n.followButton:disabled,\n.unfollowButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.closeButton {\n  display: inline-flex;\n  align-items: center;\n  padding: 0;\n  border: none;\n  background: none;\n  color: #a1a1aa;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    color: #52525b;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #18181b;\n    outline-offset: 2px;\n  }\n}\n\n.caption {\n  font-size: 15px;\n  color: #52525b;\n  line-height: 1.5;\n  margin-bottom: 8px;\n}\n\n.taskDescription {\n  font-size: 15px;\n  color: #52525b;\n  line-height: 1.5;\n  margin-bottom: 8px;\n}\n\n.badgesRow {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.waitingStatusBadge {\n  background: #eff6ff;\n  color: #0b79b7;\n  border: 1px solid #93c5fd;\n}\n\n.athenaLinkWrap {\n  margin-top: 8px;\n}\n\n.sectionLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #71717a;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 6px;\n  line-height: 1.3333;\n}\n\n.evidenceSpacer {\n  flex: 1;\n}\n\n.evidenceRef {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 9px;\n  color: #a1a1aa;\n}\n\n.evidenceSummary {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #27272a;\n}\n\n.evidenceSource {\n  font-size: 15px;\n  line-height: 1.5;\n  color: #3f3f46;\n}\n\n.evidenceSourceRef {\n  display: block;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  line-height: 1.4;\n  color: #a1a1aa;\n  word-break: break-all;\n}\n\n.sopText {\n  font-size: 15px;\n  line-height: 1.5;\n  color: #3f3f46;\n}\n\n.linkedTasksList {\n  display: flex;\n  flex-direction: column;\n}\n\n.linkedTaskRow {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 10px 16px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.linkedTaskRow:hover {\n  background: #fafafa;\n}\n\n.linkedTaskRow:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.linkedTaskTitle {\n  display: block;\n  font-size: 15px;\n  font-weight: 500;\n  color: #18181b;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.linkedTaskMeta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.linkedTaskOwner {\n  font-size: 13px;\n  color: #71717a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.linkedTaskDue {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  color: #a1a1aa;\n  white-space: nowrap;\n}\n\n.subtasksList {\n  display: flex;\n  flex-direction: column;\n}\n\n.subtaskRow {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n  min-width: 0;\n}\n\n.subtaskRow:hover {\n  background: #fafafa;\n}\n\n.subtaskRow:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.subtaskRowCompleted {\n  border-color: #bbf7d0;\n  border-left: 2px solid #86efac;\n  background: #f0fdf4;\n  padding-left: 8px;\n}\n\n.subtaskRowCompleted:hover {\n  border-color: #86efac;\n  background: #f0fdf4;\n}\n\n.subtaskRowCanceled {\n  border-color: #fecaca;\n  border-left: 2px solid #f87171;\n  background: #fef2f2;\n  padding-left: 8px;\n}\n\n.subtaskRowCanceled:hover {\n  border-color: #f87171;\n  background: #fef2f2;\n}\n\n.subtaskStatusDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #f59e0b;\n  flex-shrink: 0;\n}\n\n.subtaskStatusDotCompleted {\n  background: #22c55e;\n}\n\n.subtaskStatusDotCanceled {\n  background: #ef4444;\n}\n\n.subtaskRowPrimary {\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.subtaskTitle {\n  display: block;\n  width: 100%;\n  font-size: 15px;\n  font-weight: 500;\n  color: #18181b;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subtaskTitleCompleted {\n  color: #166534;\n  text-decoration: line-through;\n}\n\n.subtaskTitleCanceled {\n  color: #b91c1c;\n  text-decoration: line-through;\n}\n\n.subtaskRowCompleted .subtaskMeta,\n.subtaskRowCompleted .subtaskDue {\n  color: #166534;\n}\n\n.subtaskRowCompleted .subtaskTeamIcon {\n  background: #dcfce7;\n  border-color: #86efac;\n  color: #166534;\n}\n\n.subtaskRowCanceled .subtaskMeta,\n.subtaskRowCanceled .subtaskDue {\n  color: #b91c1c;\n}\n\n.subtaskRowCanceled .subtaskTeamIcon {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n.subtaskRowMeta {\n  min-width: 0;\n  width: 132px;\n  flex: 0 0 132px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n\n.subtaskTeamWrap {\n  min-width: 0;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n\n.subtaskTeamIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  color: #b45309;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.subtaskMeta {\n  min-width: 0;\n  font-size: 13px;\n  color: #71717a;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subtaskDue {\n  flex: 0 0 70px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  color: #a1a1aa;\n  text-align: right;\n}\n\n.subtaskDueUrgent {\n  color: #b91c1c;\n}\n\n.subtaskTrashButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 0;\n  flex: 0 0 24px;\n  border-radius: 4px;\n  background: transparent;\n  color: #a1a1aa;\n  cursor: pointer;\n}\n\n.subtaskTrashButton:hover:not(:disabled) {\n  background: #f4f4f5;\n  color: #71717a;\n}\n\n.subtaskTrashButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.subtaskTrashButtonDisabled {\n  cursor: default;\n  opacity: 0.45;\n}\n\n.parentTaskCard {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 16px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n}\n\n.parentTaskCard:hover {\n  background: transparent;\n}\n\n.parentTaskCard:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.parentTaskIconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  color: #9ca3af;\n}\n\n.parentTaskIcon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 1.8;\n}\n\n.parentTaskCopy {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.parentTaskTitle {\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n  line-height: 1.35;\n}\n\n.parentTaskSummary {\n  font-size: 11px;\n  color: #71717a;\n  line-height: 1.45;\n}\n\n.parentTaskMeta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 11px;\n  color: #a1a1aa;\n  line-height: 1.35;\n}\n\n.parentTaskOwnerWrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.parentTaskOwnerBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: #e5e7eb;\n  color: #52525b;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.parentTaskArrow {\n  width: 14px;\n  height: 14px;\n  color: #a1a1aa;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.assessmentBadgesRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.assessmentTypeBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 3px 8px;\n  border: 1px solid #c4b5fd;\n  border-radius: 4px;\n  background: #f3e8ff;\n  color: #6d28d9;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.assessmentVariantBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 3px 8px;\n  border: 1px solid #d4d4d8;\n  border-radius: 4px;\n  background: #ffffff;\n  color: #3f3f46;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.caregiverAssistedBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  padding: 3px 8px;\n  border: 1px solid #fde68a;\n  border-radius: 4px;\n  background: #fffbeb;\n  color: #92400e;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.sectionActions {\n  display: flex;\n  flex-direction: column;\n}\n\n.primaryActionSection {\n  padding: 12px 20px;\n  background: #ffffff;\n}\n\n.primaryActionsRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 6px;\n}\n\n.decisionGroup {\n  grid-column: 1 / -1;\n}\n\n.decisionGroup + .cancelTaskAction {\n  grid-column: 1 / -1;\n}\n\n.decisionActionsRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));\n  gap: 6px;\n}\n\n.secondaryActionSection {\n  padding: 12px 20px;\n  background: #fafafa;\n  border-top: 1px solid #f4f4f5;\n}\n\n.secondaryActionSectionStandalone {\n  border-top: none;\n}\n\n.cancelReasonPanel {\n  margin-top: 8px;\n}\n\n.cancelReasonInput {\n  width: 100%;\n  min-height: 72px;\n  resize: vertical;\n  padding: 8px 10px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #27272a;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n}\n\n.cancelReasonInput:focus {\n  outline: 2px solid #a1a1aa;\n  outline-offset: 1px;\n}\n\n.cancelActionRow {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.cancelTaskAction {\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.cancelTaskAction:hover,\n.cancelTaskAction:focus-visible {\n  background: #fef2f2;\n}\n\n.cancelTaskAction:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.primaryAction {\n  width: 100%;\n  padding: 8px 16px;\n  margin-bottom: 2px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 6px;\n  border: none;\n  background: #18181b;\n  color: #fafafa;\n  cursor: pointer;\n}\n\n.primaryAction:disabled,\n.assessmentCompleteAction:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.blockedIndicatorAction {\n  grid-column: 1 / -1;\n  background: #f4f4f5;\n  color: #a1a1aa;\n  border: 1px solid #e4e4e7;\n}\n\n.blockedIndicatorAction:disabled {\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n.cancelTaskAction.cancelTaskActionFullWidth {\n  grid-column: 1 / -1;\n  width: 100%;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  background: #dc2626;\n  border-color: #dc2626;\n}\n\n.cancelTaskAction.cancelTaskActionFullWidth:hover,\n.cancelTaskAction.cancelTaskActionFullWidth:focus-visible {\n  background: #b91c1c;\n  border-color: #b91c1c;\n}\n\n.primaryAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.assessmentCompleteAction {\n  width: 100%;\n  padding: 8px 16px;\n  margin-bottom: 2px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.assessmentCompleteAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.secondaryAction {\n  padding: 4px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 5px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.secondaryActionsRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n.secondaryActionsRowClaimed {\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.secondaryActionsGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n\n.secondaryActionsStatusGroupClaimed {\n  width: 100%;\n}\n\n.statusActionWrap {\n  position: relative;\n}\n\n.secondaryAction:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n@media (max-width: 720px) {\n  .secondaryActionsRow {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .secondaryActionsGroup {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n}.blockDropdown {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 8px);\n  width: 200px;\n  padding: 4px 0;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);\n  z-index: 10;\n}\n\n.blockDropdownItem {\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  color: #52525b;\n  font-size: 14px;\n  line-height: 1.2;\n  text-align: left;\n  cursor: pointer;\n}\n\n.blockDropdownItem:hover,\n.blockDropdownItem:focus-visible {\n  background: #fafafa;\n  outline: none;\n}\n\n.escalateDropdown {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 8px);\n  width: 240px;\n  padding: 12px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(24, 24, 27, 0.14);\n  z-index: 10;\n}\n\n.escalateDropdownLabel {\n  margin-bottom: 6px;\n  color: #71717a;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.escalateTargetOptions {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.escalateTargetOption {\n  padding: 6px 8px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #52525b;\n  font-size: 12px;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.escalateTargetOption:hover,\n.escalateTargetOption:focus-visible {\n  background: #fafafa;\n  outline: none;\n}\n\n.escalateTargetOptionActive {\n  background: #ffffff;\n  border-color: #18181b;\n  color: #18181b;\n  font-weight: 600;\n}\n\n.escalateReasonInput {\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 8px 10px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  color: #18181b;\n  font-size: 14px;\n}\n\n.escalateReasonInput:focus {\n  border-color: #f59e0b;\n  outline: none;\n}\n\n.escalateSubmitButton {\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 6px;\n  background: #fbbf24;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.escalateSubmitButton:hover,\n.escalateSubmitButton:focus-visible {\n  background: #f59e0b;\n  outline: none;\n}\n\n.escalateSubmitButton:disabled {\n  background: #fcd34d;\n  cursor: not-allowed;\n}\n\n.alertAction {\n  padding: 4px 10px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #3f3f46;\n  background: #ffffff;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: #a1a1aa;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n}\n\n.statusActionLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.headline {\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.taskVisitLine {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.375;\n  color: #18181b;\n}\n\n.taskVisitName {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\n.taskVisitWhen {\n  font-size: 13px;\n  font-variant-numeric: tabular-nums;\n  color: #71717a;\n}\n\n.summary {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 20px;\n\n  > * {\n    margin: 0;\n  }\n}\n\n.memberName {\n  font-size: 15px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.memberMeta {\n  font-size: 14px;\n  color: #3f3f46;\n}\n\n.mrn {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.linkRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin: 0 -8px;\n}\n\n.quiet {\n  font-size: 14px;\n  color: #71717a;\n}\n\n.bookingMeta {\n  font-size: 14px;\n  color: #3f3f46;\n}\n\n.taskFacts {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 0 13px;\n  margin: 0;\n  font-size: 14px;\n\n  dt {\n    color: #71717a;\n  }\n\n  dd {\n    margin: 0;\n    color: #18181b;\n  }\n}\n\n.dueUrgent {\n  font-weight: 600;\n  color: #991b1b;\n}\n\n.summaryBadge {\n  font-size: 13px;\n  line-height: 22px;\n  padding: 0 8px;\n}\n\n.topics {\n  container-type: inline-size;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #e4e4e7;\n}\n\n\n.linkedTaskRow + .linkedTaskRow,\n.subtaskRow + .subtaskRow {\n  border-top: 1px solid #f4f4f5;\n}\n\n.subtaskRow {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto auto;\n  align-items: center;\n  column-gap: 8px;\n  row-gap: 2px;\n}\n\n.subtaskStatusDot {\n  grid-column: 1;\n  grid-row: 1 / span 2;\n}\n\n.subtaskRowPrimary {\n  grid-column: 2 / 4;\n  grid-row: 1;\n}\n\n.subtaskRowMeta {\n  grid-column: 2;\n  grid-row: 2;\n}\n\n.subtaskDue {\n  grid-column: 3;\n  grid-row: 2;\n}\n\n.subtaskTrashButton {\n  grid-column: 4;\n  grid-row: 1 / span 2;\n}\n\n.primaryActionsRow .secondaryAction {\n  padding: 8px 16px;\n  font-size: 14px;\n}\n\n.sopLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n\n  &:disabled {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n\n.delegateMore {\n  @include line-button;\n  font-size: 13px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TaskDetail-module__font-s-10___tk8bX`,
	"fontS12": `TaskDetail-module__font-s-12___lPmfs`,
	"fontS13": `TaskDetail-module__font-s-13___jMsWZ`,
	"fontS14": `TaskDetail-module__font-s-14___KkptG`,
	"fontS15": `TaskDetail-module__font-s-15___JX3zU`,
	"fontS16": `TaskDetail-module__font-s-16___W7KdN`,
	"fontS18": `TaskDetail-module__font-s-18___pdGeJ`,
	"fontS20": `TaskDetail-module__font-s-20___fN8a1`,
	"fontS22": `TaskDetail-module__font-s-22___IBFHB`,
	"fontS28": `TaskDetail-module__font-s-28___BulW0`,
	"fontW400": `TaskDetail-module__font-w-400___PR_7X`,
	"fontW500": `TaskDetail-module__font-w-500___vy399`,
	"fontW600": `TaskDetail-module__font-w-600___n73JD`,
	"fontW700": `TaskDetail-module__font-w-700___Y17WW`,
	"p5": `TaskDetail-module__p-5___ohf1p`,
	"p12": `TaskDetail-module__p-12___lFh0h`,
	"p16": `TaskDetail-module__p-16___yeWHQ`,
	"p30": `TaskDetail-module__p-30___GINf6`,
	"pB0": `TaskDetail-module__p-b-0___GtEQT`,
	"pB5": `TaskDetail-module__p-b-5___rsS4j`,
	"pB10": `TaskDetail-module__p-b-10___eElco`,
	"pB12": `TaskDetail-module__p-b-12___U016T`,
	"pB16": `TaskDetail-module__p-b-16___k4cBh`,
	"pB18": `TaskDetail-module__p-b-18___nTBD1`,
	"pB20": `TaskDetail-module__p-b-20___d1AFg`,
	"pB25": `TaskDetail-module__p-b-25___csfVz`,
	"pB30": `TaskDetail-module__p-b-30___n1VVu`,
	"pB50": `TaskDetail-module__p-b-50___O0NEU`,
	"pT0": `TaskDetail-module__p-t-0___GFnBe`,
	"pT12": `TaskDetail-module__p-t-12___noQWS`,
	"pT16": `TaskDetail-module__p-t-16___qzJgK`,
	"pT18": `TaskDetail-module__p-t-18___LOl2g`,
	"pT20": `TaskDetail-module__p-t-20___ZP6Kx`,
	"pT30": `TaskDetail-module__p-t-30___yTwam`,
	"pT40": `TaskDetail-module__p-t-40___kYZaw`,
	"pT50": `TaskDetail-module__p-t-50___xmshq`,
	"pL20": `TaskDetail-module__p-l-20___Gq8r7`,
	"pL30": `TaskDetail-module__p-l-30___SpKD5`,
	"pL40": `TaskDetail-module__p-l-40___E_KDJ`,
	"pR16": `TaskDetail-module__p-r-16___M6ov0`,
	"pR20": `TaskDetail-module__p-r-20___Riw2T`,
	"pR30": `TaskDetail-module__p-r-30___DVmhn`,
	"pR50": `TaskDetail-module__p-r-50___k0WFK`,
	"pR60": `TaskDetail-module__p-r-60___dbf1G`,
	"mB1": `TaskDetail-module__m-b-1___q7Kg3`,
	"mB2": `TaskDetail-module__m-b-2___UYZPZ`,
	"mB6": `TaskDetail-module__m-b-6___CZp99`,
	"mB8": `TaskDetail-module__m-b-8___vLTXF`,
	"mB10": `TaskDetail-module__m-b-10___tj_vr`,
	"mB14": `TaskDetail-module__m-b-14___I6Kxw`,
	"mB16": `TaskDetail-module__m-b-16___PjnmT`,
	"mB20": `TaskDetail-module__m-b-20___u06vk`,
	"mB22": `TaskDetail-module__m-b-22___LZQLF`,
	"mB24": `TaskDetail-module__m-b-24___YElEx`,
	"mB30": `TaskDetail-module__m-b-30___tePlO`,
	"mB32": `TaskDetail-module__m-b-32___lVOyk`,
	"mB40": `TaskDetail-module__m-b-40___LnAGP`,
	"mT2": `TaskDetail-module__m-t-2___TE0KV`,
	"mT3": `TaskDetail-module__m-t-3___vgQ9T`,
	"mT4": `TaskDetail-module__m-t-4___gbJ2t`,
	"mT5": `TaskDetail-module__m-t-5___rFhss`,
	"mT8": `TaskDetail-module__m-t-8___mrBzG`,
	"mT10": `TaskDetail-module__m-t-10___XGahh`,
	"mT15": `TaskDetail-module__m-t-15___ION80`,
	"mT16": `TaskDetail-module__m-t-16___pOAMU`,
	"mT20": `TaskDetail-module__m-t-20___VetFR`,
	"mT22": `TaskDetail-module__m-t-22___k6IOt`,
	"mT30": `TaskDetail-module__m-t-30___kI4ku`,
	"mT32": `TaskDetail-module__m-t-32___QUZdu`,
	"mLAuto": `TaskDetail-module__m-l-auto___ERvRW`,
	"mL4": `TaskDetail-module__m-l-4___iRW1g`,
	"mL5": `TaskDetail-module__m-l-5___t564O`,
	"mL6": `TaskDetail-module__m-l-6___E3FXp`,
	"mL8": `TaskDetail-module__m-l-8___3xEKS`,
	"mL10": `TaskDetail-module__m-l-10___vF9bl`,
	"mL16": `TaskDetail-module__m-l-16___EZ8cb`,
	"mL20": `TaskDetail-module__m-l-20___YZqc7`,
	"mL24": `TaskDetail-module__m-l-24___wBeOE`,
	"mL30": `TaskDetail-module__m-l-30___PEl9Z`,
	"mL35": `TaskDetail-module__m-l-35___QWf8V`,
	"mL40": `TaskDetail-module__m-l-40___Um8pQ`,
	"mR8": `TaskDetail-module__m-r-8___tAvnT`,
	"mR10": `TaskDetail-module__m-r-10___Valsh`,
	"mR16": `TaskDetail-module__m-r-16___uBptO`,
	"mR20": `TaskDetail-module__m-r-20___DW3qE`,
	"mR24": `TaskDetail-module__m-r-24___BWeQu`,
	"mR30": `TaskDetail-module__m-r-30___jnnvP`,
	"mR40": `TaskDetail-module__m-r-40___YV94l`,
	"borderR3": `TaskDetail-module__border-r-3___QLgWp`,
	"borderR4": `TaskDetail-module__border-r-4___l5OCZ`,
	"borderR6": `TaskDetail-module__border-r-6___t0l36`,
	"borderR10": `TaskDetail-module__border-r-10___OO3gM`,
	"borderR12": `TaskDetail-module__border-r-12___y5nzh`,
	"borderR16": `TaskDetail-module__border-r-16___f4Xq_`,
	"borderR50": `TaskDetail-module__border-r-50___HLy9h`,
	"primaryBorder": `TaskDetail-module__primary-border___l5B3m`,
	"primaryBorderB": `TaskDetail-module__primary-border-b___jNPSd`,
	"primaryBorderT": `TaskDetail-module__primary-border-t___lSGqD`,
	"primaryBorderL": `TaskDetail-module__primary-border-l___ZelvH`,
	"primaryBorderR": `TaskDetail-module__primary-border-r___CfDnj`,
	"secondaryBorder": `TaskDetail-module__secondary-border___N1_1j`,
	"secondaryBorderB": `TaskDetail-module__secondary-border-b___uY5SI`,
	"secondaryBorderT": `TaskDetail-module__secondary-border-t___Ij6dL`,
	"secondaryBorderL": `TaskDetail-module__secondary-border-l___WLzs2`,
	"secondaryBorderR": `TaskDetail-module__secondary-border-r___WT6Qw`,
	"gap0": `TaskDetail-module__gap-0___UrW_Q`,
	"gap2": `TaskDetail-module__gap-2___e_xvZ`,
	"gap4": `TaskDetail-module__gap-4___bSMd7`,
	"gap5": `TaskDetail-module__gap-5___K80b6`,
	"gap6": `TaskDetail-module__gap-6___O2KXM`,
	"gap8": `TaskDetail-module__gap-8___PlawC`,
	"gap10": `TaskDetail-module__gap-10___J8s2e`,
	"gap12": `TaskDetail-module__gap-12___xpTJJ`,
	"gap14": `TaskDetail-module__gap-14___vA9qP`,
	"gap16": `TaskDetail-module__gap-16___eLwIr`,
	"gap18": `TaskDetail-module__gap-18___XbDTV`,
	"gap20": `TaskDetail-module__gap-20___eljzZ`,
	"gap24": `TaskDetail-module__gap-24___fP7QS`,
	"gap26": `TaskDetail-module__gap-26___Hmtxl`,
	"gap30": `TaskDetail-module__gap-30___sigpu`,
	"gap32": `TaskDetail-module__gap-32___T1oMc`,
	"gap40": `TaskDetail-module__gap-40___pcfpN`,
	"gap50": `TaskDetail-module__gap-50___TAmEH`,
	"flex1": `TaskDetail-module__flex-1___HXeq7`,
	"flexNone": `TaskDetail-module__flex-none___IOhvU`,
	"flexColumn": `TaskDetail-module__flex-column___C64Px`,
	"flexRow": `TaskDetail-module__flex-row___qq5oD`,
	"verticallyCentered": `TaskDetail-module__vertically-centered___zhMKo`,
	"horizontallyCentered": `TaskDetail-module__horizontally-centered___ko2IX`,
	"horizontallyEnd": `TaskDetail-module__horizontally-end___n6lOR`,
	"verticallyStart": `TaskDetail-module__vertically-start___fVBgS`,
	"spaceBetween": `TaskDetail-module__space-between___p7B6D`,
	"flexWrap": `TaskDetail-module__flex-wrap___RaAGC`,
	"height100": `TaskDetail-module__height-100___y0RMb`,
	"width50": `TaskDetail-module__width-50___ccOm6`,
	"width100": `TaskDetail-module__width-100___lixaj`,
	"cursorPointer": `TaskDetail-module__cursor-pointer___nxTPC`,
	"cursorNotAllowed": `TaskDetail-module__cursor-not-allowed___c_XL7`,
	"absoluteCentered": `TaskDetail-module__absolute-centered___PM4dB`,
	"absolute": `TaskDetail-module__absolute___iAxYP`,
	"relative": `TaskDetail-module__relative___hSStO`,
	"fixed": `TaskDetail-module__fixed___BpqPW`,
	"visible": `TaskDetail-module__visible___emUhv`,
	"invisible": `TaskDetail-module__invisible___HgKNF`,
	"col90": `TaskDetail-module__col-90___QqMKn`,
	"colAuto": `TaskDetail-module__col-auto___m9pOB`,
	"medicalTabs": `TaskDetail-module__medical-tabs___xV_P3`,
	"medicalTableNew": `TaskDetail-module__medical-table-new___AGGSt`,
	"noPagination": `TaskDetail-module__no-pagination___i4AJ3`,
	"medicalTableEmpty": `TaskDetail-module__medical-table-empty___SwkK2`,
	"iconBtn": `TaskDetail-module__icon-btn___H480f`,
	"searchIcon": `TaskDetail-module__search-icon___RewJg`,
	"disableSelect": `TaskDetail-module__disable-select___JlXRf`,
	"breakWord": `TaskDetail-module__break-word___KYwX7`,
	"popupClearBtn": `TaskDetail-module__popup-clear-btn___L8gd6`,
	"scrollMB20": `TaskDetail-module__scroll-m-b-20___AtkMB`,
	"root": `TaskDetail-module__root___nWvUV`,
	"unclaimedBanner": `TaskDetail-module__unclaimedBanner___Uu_dM`,
	"claimedBanner": `TaskDetail-module__claimedBanner___Cwl0n`,
	"followingBanner": `TaskDetail-module__followingBanner___ljM3I`,
	"claimButtonWrap": `TaskDetail-module__claimButtonWrap___xZgxS`,
	"claimNote": `TaskDetail-module__claimNote___VlEiP`,
	"claimNoteOk": `TaskDetail-module__claimNoteOk___lFDBB`,
	"claimNoteOver": `TaskDetail-module__claimNoteOver___X8E9q`,
	"claimNoteBreach": `TaskDetail-module__claimNoteBreach___mEaUH`,
	"systemBanner": `TaskDetail-module__systemBanner___TFn9i`,
	"systemBannerCopy": `TaskDetail-module__systemBannerCopy___k9PIY`,
	"systemLabel": `TaskDetail-module__systemLabel___jpnx3`,
	"systemText": `TaskDetail-module__systemText___bAq0p`,
	"capacityWarningBanner": `TaskDetail-module__capacityWarningBanner___GnEKz`,
	"capacityWarningBannerOver": `TaskDetail-module__capacityWarningBannerOver___M5iDA`,
	"capacityWarningBannerBreach": `TaskDetail-module__capacityWarningBannerBreach___UvG7l`,
	"capacityWarningTitle": `TaskDetail-module__capacityWarningTitle___b3PV5`,
	"capacityWarningText": `TaskDetail-module__capacityWarningText___MMatA`,
	"capacityWarningSlaText": `TaskDetail-module__capacityWarningSlaText___xItDE`,
	"waitingOnSubtasksBanner": `TaskDetail-module__waitingOnSubtasksBanner___IQK2l`,
	"allSubtasksCompletedBanner": `TaskDetail-module__allSubtasksCompletedBanner___WuTf5`,
	"blockedBanner": `TaskDetail-module__blockedBanner___f5Ng4`,
	"completedBanner": `TaskDetail-module__completedBanner___qP_6H`,
	"canceledBanner": `TaskDetail-module__canceledBanner___z2FX_`,
	"unableToCompleteBanner": `TaskDetail-module__unableToCompleteBanner___u20gb`,
	"unclaimedBannerCopy": `TaskDetail-module__unclaimedBannerCopy___KsOXK`,
	"claimedBannerCopy": `TaskDetail-module__claimedBannerCopy___nU7EE`,
	"blockedBannerCopy": `TaskDetail-module__blockedBannerCopy___zX_R1`,
	"waitingOnSubtasksCopy": `TaskDetail-module__waitingOnSubtasksCopy___a5RuY`,
	"allSubtasksCompletedCopy": `TaskDetail-module__allSubtasksCompletedCopy___stkyI`,
	"blockedBannerIconWrap": `TaskDetail-module__blockedBannerIconWrap___Ghhy6`,
	"waitingOnSubtasksIconWrap": `TaskDetail-module__waitingOnSubtasksIconWrap___rttwb`,
	"allSubtasksCompletedIconWrap": `TaskDetail-module__allSubtasksCompletedIconWrap___IJaZT`,
	"blockedBannerIcon": `TaskDetail-module__blockedBannerIcon___xiAb9`,
	"waitingOnSubtasksIcon": `TaskDetail-module__waitingOnSubtasksIcon___MCFcZ`,
	"allSubtasksCompletedIcon": `TaskDetail-module__allSubtasksCompletedIcon___tfDfM`,
	"unclaimedLabel": `TaskDetail-module__unclaimedLabel___CCP_L`,
	"unclaimedText": `TaskDetail-module__unclaimedText___clcKS`,
	"followingLabel": `TaskDetail-module__followingLabel___IgUXj`,
	"claimedLabel": `TaskDetail-module__claimedLabel___IKRXJ`,
	"claimedDot": `TaskDetail-module__claimedDot___vN0xw`,
	"blockedLabel": `TaskDetail-module__blockedLabel___msHYi`,
	"waitingOnSubtasksLabel": `TaskDetail-module__waitingOnSubtasksLabel___wbb1Z`,
	"allSubtasksCompletedLabel": `TaskDetail-module__allSubtasksCompletedLabel___kPTJl`,
	"waitingOnSubtasksText": `TaskDetail-module__waitingOnSubtasksText___gGjn6`,
	"allSubtasksCompletedText": `TaskDetail-module__allSubtasksCompletedText___uIFN1`,
	"blockedWaitingText": `TaskDetail-module__blockedWaitingText___M7P3z`,
	"blockedWaitingLabel": `TaskDetail-module__blockedWaitingLabel___Iqkdz`,
	"completedLabel": `TaskDetail-module__completedLabel___EDMgd`,
	"canceledLabel": `TaskDetail-module__canceledLabel___Nzsj5`,
	"unableToCompleteLabel": `TaskDetail-module__unableToCompleteLabel___KOaWO`,
	"completedCheck": `TaskDetail-module__completedCheck___J_qDv`,
	"canceledMark": `TaskDetail-module__canceledMark___W5Wni`,
	"unableToCompleteMark": `TaskDetail-module__unableToCompleteMark___op5tA`,
	"priorityBadge": `TaskDetail-module__priorityBadge___ADfFk`,
	"priorityBadgecritical": `TaskDetail-module__priorityBadgecritical___JucaQ`,
	"priorityBadgehigh": `TaskDetail-module__priorityBadgehigh___jyZfd`,
	"priorityBadgemedium": `TaskDetail-module__priorityBadgemedium___I6IMI`,
	"priorityBadgelow": `TaskDetail-module__priorityBadgelow___gF1Z8`,
	"claimedTime": `TaskDetail-module__claimedTime___MtNCK`,
	"unclaimedBannerActions": `TaskDetail-module__unclaimedBannerActions___fbYRt`,
	"followingBannerActions": `TaskDetail-module__followingBannerActions___ZREd_`,
	"claimButton": `TaskDetail-module__claimButton___AuLFq`,
	"claimButtonBreach": `TaskDetail-module__claimButtonBreach___Wv_CV`,
	"followButton": `TaskDetail-module__followButton___YD50W`,
	"unfollowButton": `TaskDetail-module__unfollowButton___EIk68`,
	"closeButton": `TaskDetail-module__closeButton___IrhIh`,
	"caption": `TaskDetail-module__caption___akEbw`,
	"taskDescription": `TaskDetail-module__taskDescription___MjbIn`,
	"badgesRow": `TaskDetail-module__badgesRow___TezKK`,
	"waitingStatusBadge": `TaskDetail-module__waitingStatusBadge___OAa6v`,
	"athenaLinkWrap": `TaskDetail-module__athenaLinkWrap___GbZ6E`,
	"sectionLabel": `TaskDetail-module__sectionLabel___ySsR2`,
	"evidenceSpacer": `TaskDetail-module__evidenceSpacer___Jw7SR`,
	"evidenceRef": `TaskDetail-module__evidenceRef___MDKDx`,
	"evidenceSummary": `TaskDetail-module__evidenceSummary___ZqYQK`,
	"evidenceSource": `TaskDetail-module__evidenceSource___d4_fe`,
	"evidenceSourceRef": `TaskDetail-module__evidenceSourceRef___HkhSh`,
	"sopText": `TaskDetail-module__sopText___ukw4Q`,
	"linkedTasksList": `TaskDetail-module__linkedTasksList___DC3Bf`,
	"linkedTaskRow": `TaskDetail-module__linkedTaskRow___h0riB`,
	"linkedTaskTitle": `TaskDetail-module__linkedTaskTitle___VKwK8`,
	"linkedTaskMeta": `TaskDetail-module__linkedTaskMeta___uyW1M`,
	"linkedTaskOwner": `TaskDetail-module__linkedTaskOwner___g9CPN`,
	"linkedTaskDue": `TaskDetail-module__linkedTaskDue___wZrH9`,
	"subtasksList": `TaskDetail-module__subtasksList____xImD`,
	"subtaskRow": `TaskDetail-module__subtaskRow___ACxYH`,
	"subtaskRowCompleted": `TaskDetail-module__subtaskRowCompleted___uzJd1`,
	"subtaskRowCanceled": `TaskDetail-module__subtaskRowCanceled___q0LFC`,
	"subtaskStatusDot": `TaskDetail-module__subtaskStatusDot___DFKGh`,
	"subtaskStatusDotCompleted": `TaskDetail-module__subtaskStatusDotCompleted___fajup`,
	"subtaskStatusDotCanceled": `TaskDetail-module__subtaskStatusDotCanceled____gQnD`,
	"subtaskRowPrimary": `TaskDetail-module__subtaskRowPrimary___nSYfm`,
	"subtaskTitle": `TaskDetail-module__subtaskTitle___jFauS`,
	"subtaskTitleCompleted": `TaskDetail-module__subtaskTitleCompleted___GDBuI`,
	"subtaskTitleCanceled": `TaskDetail-module__subtaskTitleCanceled___d6ibn`,
	"subtaskMeta": `TaskDetail-module__subtaskMeta___Lp3DD`,
	"subtaskDue": `TaskDetail-module__subtaskDue___MgjVl`,
	"subtaskTeamIcon": `TaskDetail-module__subtaskTeamIcon___xb1IZ`,
	"subtaskRowMeta": `TaskDetail-module__subtaskRowMeta___DRJ9D`,
	"subtaskTeamWrap": `TaskDetail-module__subtaskTeamWrap___eRzKd`,
	"subtaskDueUrgent": `TaskDetail-module__subtaskDueUrgent___caCtc`,
	"subtaskTrashButton": `TaskDetail-module__subtaskTrashButton___Zj9fU`,
	"subtaskTrashButtonDisabled": `TaskDetail-module__subtaskTrashButtonDisabled___HYGH2`,
	"parentTaskCard": `TaskDetail-module__parentTaskCard___NPVLb`,
	"parentTaskIconWrap": `TaskDetail-module__parentTaskIconWrap___XnChB`,
	"parentTaskIcon": `TaskDetail-module__parentTaskIcon___hB4nN`,
	"parentTaskCopy": `TaskDetail-module__parentTaskCopy___EUGMt`,
	"parentTaskTitle": `TaskDetail-module__parentTaskTitle___sl_Fv`,
	"parentTaskSummary": `TaskDetail-module__parentTaskSummary___EUcvU`,
	"parentTaskMeta": `TaskDetail-module__parentTaskMeta___QooHR`,
	"parentTaskOwnerWrap": `TaskDetail-module__parentTaskOwnerWrap___doTjs`,
	"parentTaskOwnerBadge": `TaskDetail-module__parentTaskOwnerBadge___B6Vn1`,
	"parentTaskArrow": `TaskDetail-module__parentTaskArrow___o1i1P`,
	"assessmentBadgesRow": `TaskDetail-module__assessmentBadgesRow____zg6h`,
	"assessmentTypeBadge": `TaskDetail-module__assessmentTypeBadge___hhPMT`,
	"assessmentVariantBadge": `TaskDetail-module__assessmentVariantBadge___xhBx9`,
	"caregiverAssistedBadge": `TaskDetail-module__caregiverAssistedBadge___JNE5l`,
	"sectionActions": `TaskDetail-module__sectionActions___bZ0yQ`,
	"primaryActionSection": `TaskDetail-module__primaryActionSection___EPr5z`,
	"primaryActionsRow": `TaskDetail-module__primaryActionsRow___CrIgJ`,
	"decisionGroup": `TaskDetail-module__decisionGroup___h4NkO`,
	"cancelTaskAction": `TaskDetail-module__cancelTaskAction___hzd73`,
	"decisionActionsRow": `TaskDetail-module__decisionActionsRow___MIayQ`,
	"secondaryActionSection": `TaskDetail-module__secondaryActionSection___bUWVZ`,
	"secondaryActionSectionStandalone": `TaskDetail-module__secondaryActionSectionStandalone___M9mT1`,
	"cancelReasonPanel": `TaskDetail-module__cancelReasonPanel___c_Wby`,
	"cancelReasonInput": `TaskDetail-module__cancelReasonInput___JYV3l`,
	"cancelActionRow": `TaskDetail-module__cancelActionRow___Y17p5`,
	"primaryAction": `TaskDetail-module__primaryAction___jWo7M`,
	"assessmentCompleteAction": `TaskDetail-module__assessmentCompleteAction___WMNjw`,
	"blockedIndicatorAction": `TaskDetail-module__blockedIndicatorAction___xPvsF`,
	"cancelTaskActionFullWidth": `TaskDetail-module__cancelTaskActionFullWidth___iW1Rp`,
	"secondaryAction": `TaskDetail-module__secondaryAction___Q7h19`,
	"secondaryActionsRow": `TaskDetail-module__secondaryActionsRow___akDaS`,
	"secondaryActionsRowClaimed": `TaskDetail-module__secondaryActionsRowClaimed___BSDTH`,
	"secondaryActionsGroup": `TaskDetail-module__secondaryActionsGroup___yIeXB`,
	"secondaryActionsStatusGroupClaimed": `TaskDetail-module__secondaryActionsStatusGroupClaimed___VdKae`,
	"statusActionWrap": `TaskDetail-module__statusActionWrap___q688q`,
	"blockDropdown": `TaskDetail-module__blockDropdown___TAMqT`,
	"blockDropdownItem": `TaskDetail-module__blockDropdownItem___x6C2y`,
	"escalateDropdown": `TaskDetail-module__escalateDropdown___eSL46`,
	"escalateDropdownLabel": `TaskDetail-module__escalateDropdownLabel___LMItM`,
	"escalateTargetOptions": `TaskDetail-module__escalateTargetOptions___OwQN3`,
	"escalateTargetOption": `TaskDetail-module__escalateTargetOption___GPXS3`,
	"escalateTargetOptionActive": `TaskDetail-module__escalateTargetOptionActive___K94Li`,
	"escalateReasonInput": `TaskDetail-module__escalateReasonInput___aFuAN`,
	"escalateSubmitButton": `TaskDetail-module__escalateSubmitButton___XjcI5`,
	"alertAction": `TaskDetail-module__alertAction___R0zuF`,
	"statusActionLabel": `TaskDetail-module__statusActionLabel____Cpk6`,
	"headline": `TaskDetail-module__headline___DK3wu`,
	"taskVisitLine": `TaskDetail-module__taskVisitLine___OUXBc`,
	"taskVisitName": `TaskDetail-module__taskVisitName___Ec6XB`,
	"taskVisitWhen": `TaskDetail-module__taskVisitWhen___ot0tf`,
	"summary": `TaskDetail-module__summary___OuzP3`,
	"memberName": `TaskDetail-module__memberName___jpXO2`,
	"memberMeta": `TaskDetail-module__memberMeta___d4vQW`,
	"mrn": `TaskDetail-module__mrn___C9c_R`,
	"linkRow": `TaskDetail-module__linkRow___reI_t`,
	"quiet": `TaskDetail-module__quiet___q0Ulj`,
	"bookingMeta": `TaskDetail-module__bookingMeta___aBYKN`,
	"taskFacts": `TaskDetail-module__taskFacts___s_HWw`,
	"dueUrgent": `TaskDetail-module__dueUrgent___EBNwB`,
	"summaryBadge": `TaskDetail-module__summaryBadge___SAmyF`,
	"topics": `TaskDetail-module__topics___wVzjD`,
	"sopLink": `TaskDetail-module__sopLink___hyy3N`,
	"delegateMore": `TaskDetail-module__delegateMore___Yfu0Q`
};
module.exports = ___CSS_LOADER_EXPORT___;
